import { pricingField } from "./pricingField";
import { useEffect, useState } from "react";
import { toast } from "../../../components/AppToast";
import { getItemList } from "../../../services/skuItem/skuItem";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { getItemListbyCode } from "../../../services/skuItem/skuItem";
import { height } from "@mui/system";
import { getHsnbyCode } from "../../../services/skuItem/skuItem";
export default function CreateSkuPricing({
  initialValues = {},
  onSubmit,
  onCancel,
  viewOnly,
}) {
  /* ---------------- STATE ---------------- */

  const [formData, setFormData] = useState({
    itemCode: "",
    itemName: "",
    retailPrice: "",
    customerDiscount: { discount: '', from: '', to: "" },
    volumeDiscount: [{ Qty: '', discount: '', validFrom: '', validTo: '' }],
    hsnCode: "",
    subscriptionCycle: "",
    subscriptionDiscount: "",
    sellPrice: "",
    onPromotion: "No",
    promotionLabel: "",
    promotionalDiscount: "",
    promotionalPrice: "",
  });

  const [itemDataList, setItemDataList] = useState([]);
  const [hsnList, setHsnList] = useState([])



  const handleDateChange = (name, value) => {
    if (name === "Valid From") {
      setFormData((prev) => ({
        ...prev,
        customerDiscount: {
          ...prev.customerDiscount,
          from: value,
        },
      }));
    }
    else if (name === "Valid To") {
      setFormData((prev) => ({
        ...prev,
        customerDiscount: {
          ...prev.customerDiscount,
          to: value,
        },
      }));
    }
    else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const handleKeyDown = ((name, e) => {
    if (e.key === "Enter") {
      try {
        if (name == 'itemCode') {
          getItem(e.target.value);
        }
        else {
          getHsn(e.target.value);
        }
      }
      catch (err) {
        console.error(err)
      }

    }
  })

  const getHsn = async (value) => {
    try {
      let res = await getHsnbyCode(value);
      if (res.length != 0) {
        setHsnList(res);
      }
    }
    catch (err) {

    }
  }


  const getItem = async (value) => {
    try {
      let res = await getItemListbyCode({ itemCode: value });
      if (res.length != 0) {
        setItemDataList(res);
      }
      else {
      }
    }
    catch (err) {

    }
  }

  const handleHsnCode = (e, value) => {
    setFormData((prev) => ({ ...prev, hsnCode: value._id }))
  }

  const handleItemCode = (e, value) => {
    setFormData((prev) => ({ ...prev, itemCode: value._id, itemName: value.itemName }));
  }

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onPushVoulmeDiscount = () => {
    setFormData((prev) => ({
      ...prev,
      volumeDiscount: [
        ...prev.volumeDiscount,
        {
          Qty: "",
          discount: "",
          validFrom: "",
          validTo: "",
        },
      ],
    }));
  };

  const onPopVoulmeDiscount = (row, rowindex) => {
    setFormData((prev) => ({ ...prev, volumeDiscount: prev.volumeDiscount.filter((_, index) => index != rowindex) }))
  }

  /* ---------------- PRICE CALCULATION ---------------- */

  useEffect(() => {
    const retail = Number(formData.retailPrice) || 0;

    let maxDiscount = 0;

    const today = new Date();
    today.setHours(0, 0, 0, 0); // remove time part
    if (formData.customerDiscount.discount && formData.customerDiscount.to) {
      if (new Date(formData.customerDiscount.to) > today || new Date(formData.customerDiscount.to) == today) {
        maxDiscount = Math.max(maxDiscount, Number(formData.customerDiscount.discount));
      }
    }

    if (formData.subscriptionDiscount) {
      maxDiscount = Math.max(
        maxDiscount,
        Number(formData.subscriptionDiscount)
      );
    }

    if (formData.onPromotion === "Yes" && formData.promotionalDiscount) {
      maxDiscount = Math.max(
        maxDiscount,
        Number(formData.promotionalDiscount)
      );
    }

    const sellPrice = retail - (retail * maxDiscount) / 100;

    setFormData((prev) => ({
      ...prev,
      sellPrice: sellPrice ? sellPrice.toFixed(2) : "",
      promotionalPrice:
        formData.onPromotion === "Yes"
          ? sellPrice.toFixed(2)
          : "",
    }));
  }, [
    formData.retailPrice,
    formData.customerDiscount,
    formData.subscriptionDiscount,
    formData.promotionalDiscount,
    formData.onPromotion,
  ]);




  /* ---------------- SUBMIT ---------------- */

  const submit = async (e) => {
    e.preventDefault();
    try {
      await onSubmit(formData);
    } catch (err) {
      toast.error("Error saving pricing");
    }
  };

  /* ---------------- EDIT MODE ---------------- */

  useEffect(() => {
    if ((viewOnly) && initialValues) {
      let fullDate = new Date(initialValues.custDiscount.validFrom);
      let splitDate = fullDate.getFullYear() + '-' + (fullDate.getMonth() + 1).toString().padStart(2, '0') + '-' + (fullDate.getDate()).toString().padStart(2, '0');
      let fullToDate = new Date(initialValues.custDiscount.validTo);
      let splitToDate = fullToDate.getFullYear() + '-' + (fullToDate.getMonth() + 1).toString().padStart(2, '0') + '-' + (fullToDate.getDate()).toString().padStart(2, '0');
      getItem(initialValues.itemCode.itemCode);
      getHsn(initialValues.hsnCode.hsnCode);
      setFormData((prev) => ({
        ...prev, ...initialValues,
        customerDiscount: { discount: initialValues.custDiscount.custDiscount, from: splitDate, to: splitToDate },
        subscriptionCycle: initialValues.subscription.subscriptionCycle,
        subscriptionDiscount: initialValues.subscription.subscriptionDiscount,
        onPromotion: initialValues.promotion.onPromotion,
        promotionLabel: initialValues.promotion.promotionLabel,
        promotionalDiscount: initialValues.promotion.promotionDiscount,
        promotionalPrice: initialValues.promotion.promotionPrice,
        itemCode: initialValues.itemCode._id,
        hsnCode: initialValues.hsnCode._id,
        volumeDiscount: initialValues.volume.map((m) => {
          return {
            Qty: m.Qty, discount: m.discount, validFrom: m.validFrom?.split("T")[0] || "", validTo: m.validTo?.split("T")[0] || ""
          }

        })
      }));
    }
  }, [viewOnly, initialValues]);

  /* ---------------- RENDER ---------------- */

  return (
    <form >
      <div className="d-flex flex-wrap gap-3">

        {pricingField.map((field) => {

          if (field.name === "promotionLabel" && formData.onPromotion !== "Yes") {
            return null;
          }

          if (field.name === "promotionalDiscount" && formData.onPromotion !== "Yes") {
            return null;
          }

          if (field.name === "promotionalPrice" && formData.onPromotion !== "Yes") {
            return null;
          }


          return (
            <div
              key={field.name}
              style={{ flex: field.name != "volumeDiscount" ? "0 0 22%" : "0 0 100%" }}
            >


              {field.name != "volumeDiscount" && <label className="form-label">
                {field.label}
                {field.required && <span className="text-danger"> *</span>}
              </label>}


              {field.type == 'combobox' && (
                <Autocomplete
                  disablePortal
                  readOnly={viewOnly}
                  options={itemDataList}
                  value={
                    itemDataList.find(item => item._id === formData.itemCode) || null

                  }

                  onChange={(e, newValue) => handleItemCode(e, newValue)}
                  onKeyDown={(e) => handleKeyDown(field.name, e)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 40,
                    }
                  }}
                  getOptionLabel={(option) => option?.itemCode || ""}
                  renderInput={(params) => <TextField {...params} label="" />}
                />
              )}

              {field.type == 'autoComplete' && (
                
                <Autocomplete
                  disablePortal
                  readOnly={viewOnly}
                  options={hsnList}
                  onKeyDown={(e) => handleKeyDown(field.name, e)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 40,
                    }
                  }}
                  value={
                    hsnList.find(item => item._id === formData.hsnCode) || null
                  }
                  onChange={(e, newValue) => handleHsnCode(e, newValue)}
                  getOptionLabel={(option) => option?.hsnCode + option?.hsnDescription || ""}
                  renderInput={(params) => <TextField {...params} label="" />}
                />
              )}

              {field.type === "select" && (
                <select
                  className="form-select"
                  value={formData[field.name] || ""}

                  onChange={(e) =>
                    handleChange(field.name, e.target.value)
                  }
                  disabled={viewOnly}
                >
                  <option value="">Select</option>
                  {field.options?.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              )}

              {/* ---------- DATE RANGE ---------- */}
              {field.type === "daterange" && (
                <div className="d-flex gap-1">
                  <input
                    type="date"
                    className="form-control"
                    value={field.name === 'Valid From' ? formData.customerDiscount?.from || "" : field.name === 'Valid To' ? formData.customerDiscount.to || "" : formData[field.name] || ""}
                    onChange={(e) => handleDateChange(field.name, e.target.value)
                    }
                    disabled={viewOnly}
                  />

                </div>
              )}



              {field.type === "text" && (
                <div className="d-flex gap-1">
                  <input
                    type="text"
                    className="form-control"
                    value={formData[field.name] || ""}
                    readOnly={field.readonly || viewOnly}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        [field.name]: {
                          ...prev[field.name],
                          from: e.target.value,
                        },
                      }))
                    }
                    disabled={viewOnly}
                  />

                </div>
              )}


              {field.type === "number" && (
                <div className="d-flex gap-1">
                  <input
                    type="number"
                    className="form-control"
                    readOnly={field.readonly || viewOnly}
                    value={field.name === 'customerDiscount' ? formData[field.name]?.discount || "" : formData[field.name] || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      setFormData((prev) => ({
                        ...prev,
                        [field.name]:
                          field.name === "customerDiscount"
                            ? {
                              ...prev[field.name],
                              discount: value,
                            }
                            : value,
                      }));
                    }}
                    disabled={viewOnly}
                  />

                </div>
              )}


              {field.type === "volumeDiscount" && (
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}> <h6>Volume Discount</h6>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={onPushVoulmeDiscount}
                      hidden={viewOnly}
                    >
                      +
                    </button></div>
                  {formData.volumeDiscount.map((row, index) => (
                    <div key={index} className="d-flex gap-3">

                      {field.fields.map((subField) => (
                        <div key={subField.name} style={{ width: '22%' }}>
                          <label>{subField.label}</label>
                          <input
                            type={subField.type}
                            className="form-control"
                            value={row[subField.name] || ""}
                            readOnly={viewOnly}
                            onChange={(e) => {
                              const updated = [...formData.volumeDiscount];
                              updated[index][subField.name] = e.target.value;

                              setFormData((prev) => ({
                                ...prev,
                                volumeDiscount: updated,
                              }));
                            }}
                          />
                        </div>
                      ))}
                      <div className="d-flex justify-content-center gap-2 mt-4">


                        {formData.volumeDiscount.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => onPopVoulmeDiscount(row, index)}
                            hidden={viewOnly}
                          >
                            -
                          </button>
                        )}
                      </div>

                    </div>
                  ))}
                </div>
              )

              }



              {field.helperText && (
                <small className="text-muted">{field.helperText}</small>
              )}

            </div>
          );
        })}
      </div>

      {/* ---------- ACTION BUTTONS ---------- */}
      <div className="d-flex justify-content-center gap-2 mt-4">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onCancel}
        >
          Back
        </button>

        {!viewOnly && (
          <button type="button" className="btn btn-primary" onClick={submit}>
            Save
          </button>
        )}
      </div>
    </form>
  );
}
